import PaymentMethods from "../components/payment/PaymentMethods/PaymentMethods";
import { useAuth } from "../context/AuthContext";
import { dictionary } from "../utils/dictionary";
function PaymentMethodPage() {
  const { language } = useAuth();
  return (
    <div className="min-h-screen bg-gray-100 p-8 ml-4">
      <h1 className="text-2xl font-bold mb-4">{dictionary["payment-methods"][language]}</h1>
      <p className="text-sm text-gray-500 mb-10">
        {dictionary["payment-methods-description"][language]}
      </p>
      <PaymentMethods />
    </div>
  );
}

export default PaymentMethodPage;
